export function getValidationErrors(error) {
	// console.log(error)
	const validationErrors =
		error.inner &&
		error.inner.reduce((x, y) => {
			x[y.path] = y.message
			return x
		}, {})
	return validationErrors
}

export function firstLetterUpper(str) {
	const lowerCaseStr = str.toLowerCase()
	return lowerCaseStr.charAt(0).toUpperCase() + lowerCaseStr.slice(1)
}

export function getFullName(givenName, lastName) {
	const givenNameFormatted = firstLetterUpper(givenName)
	const familyNameFormatted = firstLetterUpper(lastName)
	const fullName = `${givenNameFormatted} ${familyNameFormatted}`
	return fullName
}

export function isStaff() {
	const isStaff =
		JSON.parse(sessionStorage.getItem('user')).profile === 'Staff'
			? true
			: false
	return isStaff
}

export function attachmentOriginalName(fileName) {
	const fileNameArray = fileName.split('.')
	const fileNameArrayLength = fileNameArray.length
	const nameArray = fileNameArray[fileNameArrayLength - 2].split('-')
	const nameArrayLength = nameArray.length
	nameArray.splice(nameArrayLength - 1, 1)
	fileNameArray[fileNameArrayLength - 2] = nameArray.join('-')
	const originalFileName = fileNameArray.join('.')
	return originalFileName
}

export function fetchFile(URL) {
	return new Promise((resolve, reject) => {
		fetch(URL)
			.then(response => {
				const blob = response.blob()
				resolve(blob)
			})
			.catch(err => reject(err))
	})
}

export function removeSpaceKey(str) {
	let strArray = str.trim().split(' ')
	let newStr = strArray.join('%20')
	return newStr
}
